import Vue from 'vue'
import textMask from '../directives/text-mask'
Vue.directive('mask', textMask)
